import React, { FC } from 'react';
import { FormInput } from '../merchants/FormInput';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { APP_VIEW_COMPANY_INPUTS } from '../../constants/application-view/company-info-inputs';
import { useMerchants } from '../../store/merchnts/merchants-context';

interface Props {
  formik: any;
  formEditStatus?: boolean;
}

export const ApplicationViewCompanyInfo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { formik, formEditStatus = true } = props;
  const { merchantState: { merchantsLists: lists, mccList }} = useMerchants();


  const INPUTS = APP_VIEW_COMPANY_INPUTS({ t, lists, mccList });

  return (
    <SectionWrapper
      title={t('NEW_APPLICATION.BUSINESS_INFORMATION')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <div className="row">
        {
          INPUTS.map(item => (
            <FormInput
              {...item}
              formik={formik}
              key={item.key}
              isEditMode={formEditStatus}
            />
          ))
        }
      </div>

    </SectionWrapper>
  );
};